import client from './api-client';

export const getConfiguracionForm35 = async(query) => {
    try {
        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form35: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getIngresoGrilla = async(query) => {
    try {
        
        const response = await client.getSelect(`gestion-implicado/recobros?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosRecobro: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

